(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[235],{

/***/ 86056:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

const NavContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext(null);
NavContext.displayName = 'NavContext';
/* harmony default export */ __webpack_exports__["Z"] = (NavContext);

/***/ }),

/***/ 73716:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ useNavItem; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _restart_hooks_useEventCallback__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78146);
/* harmony import */ var _NavContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86056);
/* harmony import */ var _SelectableContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87126);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(70861);
/* harmony import */ var _DataKey__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52747);
/* harmony import */ var _TabContext__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(76626);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);
const _excluded = ["as", "active", "eventKey"];

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }










function useNavItem({
  key,
  onClick,
  active,
  id,
  role,
  disabled
}) {
  const parentOnSelect = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_SelectableContext__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z);
  const navContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_NavContext__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z);
  const tabContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_TabContext__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z);
  let isActive = active;
  const props = {
    role
  };

  if (navContext) {
    if (!role && navContext.role === 'tablist') props.role = 'tab';
    const contextControllerId = navContext.getControllerId(key != null ? key : null);
    const contextControlledId = navContext.getControlledId(key != null ? key : null); // @ts-ignore

    props[(0,_DataKey__WEBPACK_IMPORTED_MODULE_6__/* .dataAttr */ .PB)('event-key')] = key;
    props.id = contextControllerId || id;
    isActive = active == null && key != null ? navContext.activeKey === key : active;
    /**
     * Simplified scenario for `mountOnEnter`.
     *
     * While it would make sense to keep 'aria-controls' for tabs that have been mounted at least
     * once, it would also complicate the code quite a bit, for very little gain.
     * The following implementation is probably good enough.
     *
     * @see https://github.com/react-restart/ui/pull/40#issuecomment-1009971561
     */

    if (isActive || !(tabContext != null && tabContext.unmountOnExit) && !(tabContext != null && tabContext.mountOnEnter)) props['aria-controls'] = contextControlledId;
  }

  if (props.role === 'tab') {
    if (disabled) {
      props.tabIndex = -1;
      props['aria-disabled'] = true;
    }

    if (isActive) {
      props['aria-selected'] = isActive;
    } else {
      props.tabIndex = -1;
    }
  }

  props.onClick = (0,_restart_hooks_useEventCallback__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(e => {
    if (disabled) return;
    onClick == null ? void 0 : onClick(e);

    if (key == null) {
      return;
    }

    if (parentOnSelect && !e.isPropagationStopped()) {
      parentOnSelect(key, e);
    }
  });
  return [props, {
    isActive
  }];
}
const NavItem = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((_ref, ref) => {
  let {
    as: Component = _Button__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP,
    active,
    eventKey
  } = _ref,
      options = _objectWithoutPropertiesLoose(_ref, _excluded);

  const [props, meta] = useNavItem(Object.assign({
    key: (0,_SelectableContext__WEBPACK_IMPORTED_MODULE_3__/* .makeEventKey */ .h)(eventKey, options.href),
    active
  }, options)); // @ts-ignore

  props[(0,_DataKey__WEBPACK_IMPORTED_MODULE_6__/* .dataAttr */ .PB)('active')] = meta.isActive;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Component, Object.assign({}, options, props, {
    ref: ref
  }));
});
NavItem.displayName = 'NavItem';
/* harmony default export */ __webpack_exports__["Z"] = (NavItem);

/***/ }),

/***/ 87126:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ makeEventKey; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

const SelectableContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext(null);
const makeEventKey = (eventKey, href = null) => {
  if (eventKey != null) return String(eventKey);
  return href || null;
};
/* harmony default export */ __webpack_exports__["Z"] = (SelectableContext);

/***/ }),

/***/ 76626:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

const TabContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext(null);
/* harmony default export */ __webpack_exports__["Z"] = (TabContext);

/***/ }),

/***/ 70710:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ LazyReveal; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
"use client";


const DefaultShimmer = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "animate-pulse bg-gray-300 h-6 w-full rounded-lg"
    });
function LazyReveal({ children , shimmer , rootMargin ="0px" , threshold =0.1 , className , onVisible , id , style  }) {
    const { 0: visible , 1: setVisible  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const wrapperRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const observerRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (!wrapperRef.current) return;
        observerRef.current = new IntersectionObserver((entries)=>{
            const entry = entries[0];
            if (entry.isIntersecting) {
                setVisible(true);
                onVisible && onVisible();
                observerRef.current?.disconnect();
            }
        }, {
            rootMargin,
            threshold
        });
        observerRef.current.observe(wrapperRef.current);
        return ()=>{
            observerRef.current?.disconnect();
        };
    }, [
        rootMargin,
        threshold
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        ref: wrapperRef,
        className: className,
        id: id,
        style: style,
        children: visible ? children : shimmer || /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DefaultShimmer, {})
    });
}


/***/ }),

/***/ 47046:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ MetaTagsComp; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59830);





const MetaTagsComp = (props)=>{
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    const currentUrl = "https://staging.studies-overseas.com" + (router.asPath || "");
    const { metaTitle , metaDescription , src , keywords , robotsMeta , ogimage , twitterimage , isCustomSchema , schemaJson , jotforms , canonicalUrl , isBlogPage  } = props;
    const structuredJSON = isCustomSchema && schemaJson ? schemaJson : _utils_constants__WEBPACK_IMPORTED_MODULE_4__/* .defaultSchema */ .R4;
    const removeQueryParameters = (url)=>{
        const currentUrl = url;
        const queryIndex = currentUrl.indexOf("?");
        return queryIndex !== -1 ? currentUrl.slice(0, queryIndex) : currentUrl;
    };
    const cleanCanonicalUrl = canonicalUrl ? removeQueryParameters(canonicalUrl) : removeQueryParameters(currentUrl);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                    children: metaTitle
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "description",
                    content: metaDescription
                }),
                keywords && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "keywords",
                    content: keywords
                }),
                robotsMeta && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "robots",
                    content: robotsMeta
                }),
                metaTitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:title",
                    content: metaTitle
                }),
                metaDescription && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:description",
                    content: metaDescription
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:url",
                    content: isBlogPage ? cleanCanonicalUrl : currentUrl
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:type",
                    content: "Organization"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:image",
                    content: ogimage || "https://www.studies-overseas.com/kc_schema_logo.png"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:site_name",
                    content: isBlogPage ? cleanCanonicalUrl : currentUrl
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                    rel: "canonical",
                    href: cleanCanonicalUrl || canonicalUrl
                }),
                src && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                    src: src
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:card",
                    content: "summary_large_image"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:site",
                    content: "@KCOverseasEdu"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:creator",
                    content: "@KCOverseasEdu"
                }),
                metaTitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:title",
                    content: metaTitle
                }),
                metaDescription && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:description",
                    content: metaDescription
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:image",
                    content: twitterimage || "https://www.studies-overseas.com/kc_schema_logo.png"
                }),
                structuredJSON && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                    className: "structured-data-list",
                    type: "application/ld+json",
                    dangerouslySetInnerHTML: {
                        __html: JSON.stringify(structuredJSON)
                    }
                })
            ]
        })
    });
};


/***/ }),

/***/ 90235:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ counsellingLanding; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./components/OverseasEdutionFair/GrabChanceSection.tsx
var GrabChanceSection = __webpack_require__(54455);
// EXTERNAL MODULE: ./styles/onlineCounselling.module.scss
var onlineCounselling_module = __webpack_require__(30555);
var onlineCounselling_module_default = /*#__PURE__*/__webpack_require__.n(onlineCounselling_module);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__(10682);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(34051);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(31555);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Nav.js + 3 modules
var Nav = __webpack_require__(80957);
// EXTERNAL MODULE: ./components/CustomImage.tsx
var CustomImage = __webpack_require__(45992);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Button.js
var Button = __webpack_require__(35005);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Breadcrumb.js + 1 modules
var Breadcrumb = __webpack_require__(26699);
// EXTERNAL MODULE: ./hooks/useZipmeLink.tsx
var useZipmeLink = __webpack_require__(98196);
// EXTERNAL MODULE: ./utils/helpers.ts + 1 modules
var helpers = __webpack_require__(32866);
;// CONCATENATED MODULE: ./components/OnlineCounselling/onlineConunsellingHeader.tsx













const HeaderSection = ({ data , jotformId , externalLink , slug  })=>{
    const { zipmeLink , generateLink  } = (0,useZipmeLink/* default */.Z)();
    const router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (onlineCounselling_module_default()).banner,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
            children: [
                (router.asPath.includes("/study-abroad-online-counselling") || router.asPath.includes("/branch/") && !router.asPath.includes("/online-counselling/")) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (onlineCounselling_module_default()).nav,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                    src: "/images/educationfair/kc_logo.svg",
                                    width: 180,
                                    height: 45,
                                    className: (onlineCounselling_module_default()).navLogo,
                                    alt: "kclogo"
                                })
                            })
                        })
                    })
                }),
                !router.asPath.includes("/study-abroad-online-counselling") && router.asPath.startsWith("/online-counselling/") && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Breadcrumb/* default */.Z, {
                    className: (onlineCounselling_module_default()).mobileBreadCrum,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumb/* default.Item */.Z.Item, {
                            href: "/",
                            style: {
                                opacity: 0.5
                            },
                            children: "Home"
                        }),
                        router.asPath === "/online-counselling" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumb/* default.Item */.Z.Item, {
                            href: "",
                            children: "Online Counselling"
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumb/* default.Item */.Z.Item, {
                                    href: "/online-counselling",
                                    style: {
                                        opacity: 0.5
                                    },
                                    children: "Online Counselling"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumb/* default.Item */.Z.Item, {
                                    href: "",
                                    children: slug === "usa" ? "USA" : slug === "uk" ? "UK" : slug.replace(/-/g, " ").replace(/\b\w/g, (char, index)=>char.toUpperCase())
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (onlineCounselling_module_default()).maincontent,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                xl: 6,
                                lg: 6,
                                md: 12,
                                xs: 12,
                                className: (onlineCounselling_module_default()).hdraside,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (onlineCounselling_module_default()).mainSectionBg,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (onlineCounselling_module_default()).sponserdSecdesk,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                    style: {
                                                        color: data?.titleColor || "#fff"
                                                    },
                                                    children: data.mainTitle
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    style: {
                                                        color: data?.subTitleColor || "#fff"
                                                    },
                                                    children: data.subTitle
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (onlineCounselling_module_default()).fairdetails,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (onlineCounselling_module_default()).ulItem,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                        children: data?.points?.length > 0 && data?.points?.map((pointImg)=>{
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                                style: {
                                                                    color: data?.pointsColor || "#fff"
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                                        src: pointImg?.imageUrl || "/images/starthd.png",
                                                                        width: 20,
                                                                        height: 20,
                                                                        alt: "EdTech1"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        children: pointImg.title
                                                                    })
                                                                ]
                                                            });
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (onlineCounselling_module_default()).regBtn,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                        onClick: ()=>{
                                                            !jotformId && generateLink(externalLink);
                                                        },
                                                        className: `${(onlineCounselling_module_default()).btnReg}${jotformId ? ` ${(0,helpers/* isFrappeOrJotFormClass */.gd)(jotformId)}` : ""}`,
                                                        children: data.button?.[0]?.label || "Register Now"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                xl: 6,
                                lg: 6,
                                md: 12,
                                xs: 12,
                                className: (onlineCounselling_module_default()).hdrbside,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (onlineCounselling_module_default()).bannerStudDiv,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (onlineCounselling_module_default()).bg,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                            src: data?.mainImageUrl || "/images/headimg.png",
                                            width: 450,
                                            height: 450,
                                            alt: "bannergirl",
                                            priority: true,
                                            isLazyLoad: false
                                        })
                                    })
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var onlineConunsellingHeader = (HeaderSection);

// EXTERNAL MODULE: ./components/OverseasEdutionFair/AccomplishSection.tsx
var AccomplishSection = __webpack_require__(79782);
;// CONCATENATED MODULE: ./components/OnlineCounselling/footer.tsx







const OnlineCounFooter = ({ data  })=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (onlineCounselling_module_default()).footer,
        style: {
            backgroundColor: data?.sectionTopBgColor || "#fff"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                    className: "text-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (onlineCounselling_module_default()).footerlogo,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                src: "/images/educationfair/kc_logo.svg",
                                width: 180,
                                height: 45,
                                className: (onlineCounselling_module_default()).navLogo,
                                alt: "kclogo"
                            })
                        })
                    })
                }),
                data?.offices?.map((office)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        children: [
                                            office.officeName,
                                            ": ",
                                            office.address
                                        ]
                                    }),
                                    office.contact && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        children: [
                                            "Contact Us: ",
                                            office.contact
                                        ]
                                    })
                                ]
                            })
                        })
                    }))
            ]
        })
    });
};
/* harmony default export */ var footer = (OnlineCounFooter);

// EXTERNAL MODULE: ./components/MetaTagsComp.tsx
var MetaTagsComp = __webpack_require__(47046);
// EXTERNAL MODULE: ./components/LazyReveal.tsx
var LazyReveal = __webpack_require__(70710);
;// CONCATENATED MODULE: ./components/OnlineCounselling/counsellingLanding.tsx










const WhyOnlineCounselling = dynamic_default()(()=>__webpack_require__.e(/* import() */ 1896).then(__webpack_require__.bind(__webpack_require__, 21896)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(21896)
            ]
    }
});
const Studyabroadjourney = dynamic_default()(()=>__webpack_require__.e(/* import() */ 4481).then(__webpack_require__.bind(__webpack_require__, 64481)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(64481)
            ]
    }
});
const WorldisyourCampus = dynamic_default()(()=>__webpack_require__.e(/* import() */ 5104).then(__webpack_require__.bind(__webpack_require__, 45104)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(45104)
            ]
    }
});
const FirstStepWithKC = dynamic_default()(()=>__webpack_require__.e(/* import() */ 4733).then(__webpack_require__.bind(__webpack_require__, 94733)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(94733)
            ]
    }
});
const Studywithscholarship = dynamic_default()(()=>__webpack_require__.e(/* import() */ 1806).then(__webpack_require__.bind(__webpack_require__, 91806)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(91806)
            ]
    }
});
const WhyChoosKcStudyAbroad = dynamic_default()(()=>__webpack_require__.e(/* import() */ 7477).then(__webpack_require__.bind(__webpack_require__, 17477)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(17477)
            ]
    }
});
const StudiesFAQ = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(6066), __webpack_require__.e(8219), __webpack_require__.e(6102)]).then(__webpack_require__.bind(__webpack_require__, 26102)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(26102)
            ]
    }
});
const UniversityTiups = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(6066), __webpack_require__.e(9392)]).then(__webpack_require__.bind(__webpack_require__, 9392)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(9392)
            ]
    },
    ssr: false
});
const EduFairStudentTestimonials = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(6066), __webpack_require__.e(1071)]).then(__webpack_require__.bind(__webpack_require__, 91071)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(91071)
            ]
    },
    ssr: false
});
const EduFairKcByNumber = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(5655), __webpack_require__.e(7057)]).then(__webpack_require__.bind(__webpack_require__, 17057)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(17057)
            ]
    },
    ssr: false
});
const CounsellingLanding = ({ eventData  })=>{
    (0,react.useEffect)(()=>{
        const customStyle = document.documentElement.style;
        customStyle.setProperty("--event-bgcolor", eventData?.bannerSection?.sectionBgColor || "#6C48F0");
    }, []);
    const router = (0,next_router.useRouter)();
    const { slug  } = router.query;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            eventData && /*#__PURE__*/ (0,jsx_runtime.jsx)(MetaTagsComp/* MetaTagsComp */.r, {
                ...eventData.meta
            }),
            eventData?.bannerSection && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(onlineConunsellingHeader, {
                    data: eventData?.bannerSection,
                    jotformId: eventData?.meta?.jotforms[0]?.jotformid,
                    externalLink: eventData?.externalLink,
                    slug: eventData?.slug
                })
            }),
            eventData?.whyKcSection && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WhyOnlineCounselling, {
                    whykcdata: eventData?.whyKcSection
                })
            }),
            eventData?.kickstartSection && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Studyabroadjourney, {
                    studyabrdata: eventData?.kickstartSection,
                    slug: `${slug}`,
                    jotformId: eventData?.meta?.jotforms[0]?.jotformid,
                    externalLink: eventData?.externalLink
                })
            }),
            eventData?.worldCampusSection && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WorldisyourCampus, {
                    worlddata: eventData?.worldCampusSection
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GrabChanceSection/* default */.Z, {
                eventData: eventData
            }),
            eventData?.tieUpsSection && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyReveal/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UniversityTiups, {
                        tiupdata: eventData?.tieUpsSection
                    })
                })
            }),
            eventData?.firstStepWithKcSection && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FirstStepWithKC, {
                    firstStepEventData: eventData?.firstStepWithKcSection,
                    jotformId: eventData?.meta?.jotforms[0]?.jotformid,
                    externalLink: eventData?.externalLink
                })
            }),
            eventData?.stepUpSection && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Studywithscholarship, {
                    studyabroadjdata: eventData?.stepUpSection,
                    jotformId: eventData?.meta?.jotforms[0]?.jotformid,
                    externalLink: eventData?.externalLink
                })
            }),
            eventData?.whyChooseKc && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WhyChoosKcStudyAbroad, {
                    data: eventData?.whyChooseKc
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AccomplishSection/* default */.Z, {
                eventData: eventData
            }),
            eventData?.studentsSaySection && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyReveal/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EduFairStudentTestimonials, {
                        data: eventData?.studentsSaySection
                    })
                })
            }),
            eventData?.kcNumbersSection && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyReveal/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EduFairKcByNumber, {
                        data: eventData?.kcNumbersSection
                    })
                })
            }),
            eventData?.faqSection && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StudiesFAQ, {
                    faqdata: eventData?.faqSection
                })
            }),
            eventData?.footer && !router.asPath.includes("/online-counselling") && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(footer, {
                    data: eventData?.footer
                })
            })
        ]
    });
};
/* harmony default export */ var counsellingLanding = (CounsellingLanding);


/***/ }),

/***/ 79782:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(21174);
/* harmony import */ var _styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(10682);
/* harmony import */ var react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(34051);
/* harmony import */ var react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(31555);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _hooks_useZipmeLink__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98196);
/* harmony import */ var _utils_helpers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32866);
/* harmony import */ var _LazyReveal__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70710);










const AccomplishSection = ({ eventData  })=>{
    const { zipmeLink , generateLink  } = (0,_hooks_useZipmeLink__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LazyReveal__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        className: (_styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_6___default().accomplishSection),
        style: {
            background: `linear-gradient(0deg, ${eventData?.accomplishSection?.sectionBgColorBottom || "#EEF2FB"} 50%, ${eventData?.accomplishSection?.sectionBgColorTop || "#ffffff"} 0)`
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_6___default().studentFooter),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_6___default().session),
                            style: {
                                backgroundColor: `${eventData?.accomplishSection?.sectionBgColor}`
                            },
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                        style: {
                                            color: eventData?.titleTextColor || eventData?.accomplishSection?.sectionTitleColor || "#fff"
                                        },
                                        children: eventData?.accomplishSection?.sectionTitle
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (_styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_6___default().anchor),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            onClick: ()=>{
                                                !eventData?.meta?.jotforms[0]?.jotformid && generateLink(eventData?.externalLink);
                                            },
                                            className: `btn btn-primary   ${eventData?.meta?.jotforms[0]?.jotformid ? ` ${(0,_utils_helpers__WEBPACK_IMPORTED_MODULE_4__/* .isFrappeOrJotFormClass */ .gd)(eventData?.meta?.jotforms[0]?.jotformid)}` : ""}`,
                                            children: eventData.accomplishSection?.button?.label || "Register Now"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                                            dangerouslySetInnerHTML: {
                                                __html: `window.lintrk('track', { conversion_id: 6870956 });`
                                            }
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AccomplishSection);


/***/ }),

/***/ 54455:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(21174);
/* harmony import */ var _styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(10682);
/* harmony import */ var react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(34051);
/* harmony import */ var react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(31555);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _hooks_useZipmeLink__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98196);
/* harmony import */ var _utils_helpers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32866);
/* harmony import */ var _LazyReveal__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70710);










const GrabChanceSection = ({ eventData  })=>{
    const { zipmeLink , generateLink  } = (0,_hooks_useZipmeLink__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LazyReveal__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        style: {
            background: `linear-gradient(0deg, ${eventData?.grabChanceSection?.sectionBgColorBottom || "#F7F8F7"} 50%, ${eventData?.grabChanceSection?.sectionBgColorTop || "#DBD9FC"} 0)`
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_6___default().studentFooter),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_6___default().session),
                            style: {
                                backgroundColor: `${eventData?.grabChanceSection?.sectionBgColor}`
                            },
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                        style: {
                                            color: eventData?.titleTextColor || eventData?.grabChanceSection?.sectionTitleColor || "#fff"
                                        },
                                        children: eventData?.grabChanceSection?.sectionTitle
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (_styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_6___default().anchor),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            onClick: ()=>{
                                                !eventData?.meta?.jotforms[0]?.jotformid && generateLink(eventData?.externalLink);
                                            },
                                            className: `btn btn-primary   ${eventData?.meta?.jotforms[0]?.jotformid ? ` ${(0,_utils_helpers__WEBPACK_IMPORTED_MODULE_4__/* .isFrappeOrJotFormClass */ .gd)(eventData?.meta?.jotforms[0]?.jotformid)}` : ""}`,
                                            children: eventData.grabChanceSection?.button?.label || "Register Now"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                                            dangerouslySetInnerHTML: {
                                                __html: `window.lintrk('track', { conversion_id: 6870956 });`
                                            }
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (GrabChanceSection);


/***/ }),

/***/ 98196:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);


const useZipmeLink = ()=>{
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    const { 0: zipmeLink , 1: setZipmeLink  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)("");
    const generateLink = (externalLink)=>{
        if (!externalLink) {
            console.warn("No external link provided!");
            return;
        }
        if (!router.isReady) return;
        const queryString = router.asPath.split("?")[1];
        const newLink = queryString ? `${externalLink}?${queryString}` : externalLink;
        setZipmeLink(newLink);
        window.open(newLink, "_blank");
    };
    return {
        zipmeLink,
        generateLink
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useZipmeLink);


/***/ }),

/***/ 21174:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"mainSectionBg":"educationFair_mainSectionBg__f9xFn","partUni":"educationFair_partUni__waZut","heading":"educationFair_heading__9gEQ7","studentTesti":"educationFair_studentTesti__x6F_4","testimonials":"educationFair_testimonials__lqDsw","kcByNumber":"educationFair_kcByNumber__ZkmbH","number":"educationFair_number__HkKJe","choosekc":"educationFair_choosekc__Vwr9m","whykc":"educationFair_whykc__5vSGW","topScholarship":"educationFair_topScholarship__5qvn_","ScholarshipStudent":"educationFair_ScholarshipStudent__uItOq","studentSpecialOffer":"educationFair_studentSpecialOffer__6LOlm","whoWillYouMeet":"educationFair_whoWillYouMeet__ywIRz","banner":"educationFair_banner__o09Lk","sponserdSecdesk":"educationFair_sponserdSecdesk__TWesk","nav":"educationFair_nav__IwAIT","navLogo":"educationFair_navLogo__a2RbS","maincontent":"educationFair_maincontent__Lf9vo","fairdetails":"educationFair_fairdetails__lQnhO","events":"educationFair_events__QXT_l","time":"educationFair_time__DGHYd","location":"educationFair_location__q6eeA","icon":"educationFair_icon__O_stz","btnReg":"educationFair_btnReg__F_B_u","regBtn":"educationFair_regBtn__eAl7i","bannerStudDiv":"educationFair_bannerStudDiv__oweS7","bg":"educationFair_bg__mB7Z3","whyattend":"educationFair_whyattend__9DHww","maindiv":"educationFair_maindiv__e3jYl","contentDiv":"educationFair_contentDiv__KZqDx","mainBox":"educationFair_mainBox__U0NP0","box":"educationFair_box__8d_P2","img":"educationFair_img__MDtHp","whoyoumeetslider":"educationFair_whoyoumeetslider__iq4CA","card":"educationFair_card__QO3LX","cardImgDiv":"educationFair_cardImgDiv__YIgbH","cardImg":"educationFair_cardImg__twGj3","cardBody":"educationFair_cardBody__QSbke","sliderDots":"educationFair_sliderDots__pxVyJ","OffersContent":"educationFair_OffersContent__QpR_A","ulItem":"educationFair_ulItem__all6_","liItem":"educationFair_liItem__R6rLJ","anchor":"educationFair_anchor__hv76g","schStImg":"educationFair_schStImg__nbwjP","schStd":"educationFair_schStd__X6DBn","SchContent":"educationFair_SchContent__0egHz","studentFooter":"educationFair_studentFooter___maMm","session":"educationFair_session__Y8wel","stuSchSlider":"educationFair_stuSchSlider__ZQ6Kd","sliderCardDiv":"educationFair_sliderCardDiv__5Nvnd","cardCust":"educationFair_cardCust__nGxCS","studeImgDiv":"educationFair_studeImgDiv__7z4sw","stuName":"educationFair_stuName__PBR4S","StdDetail":"educationFair_StdDetail__CyjJi","arrowsClasses":"educationFair_arrowsClasses__QxU4_","btcircle":"educationFair_btcircle__gKp8O","col":"educationFair_col__4EaZs","studVedio":"educationFair_studVedio__nlAM_","studenSay":"educationFair_studenSay__kp1ip","stupara":"educationFair_stupara__aRQBw","stImg":"educationFair_stImg__WravK","clickTabsCountry":"educationFair_clickTabsCountry__CV_tU","flagsapn":"educationFair_flagsapn__k2m7j","countryFlag":"educationFair_countryFlag__CaX7T","countryBox":"educationFair_countryBox___lVYR","flag":"educationFair_flag__JcPo4","ClickshowUniLogo":"educationFair_ClickshowUniLogo__zTBns","uniLogodiv":"educationFair_uniLogodiv__ahGRq","uniImg":"educationFair_uniImg__2yFZZ","UniFlagImg":"educationFair_UniFlagImg__vm3pF","footerbg":"educationFair_footerbg__GwKRk","footer":"educationFair_footer__566jv","content":"educationFair_content__c6N9c","footerLogo":"educationFair_footerLogo__sR7MV","address":"educationFair_address__azyE2","tagline":"educationFair_tagline__h4hlS","foterReg":"educationFair_foterReg__27mpH","ngpWhyAttend":"educationFair_ngpWhyAttend__apAKJ","activeClass":"educationFair_activeClass__bxqcH","arrowsClass":"educationFair_arrowsClass__mfj0d"};

/***/ }),

/***/ 30555:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"banner":"onlineCounselling_banner__nXf5D","sponserdSecdesk":"onlineCounselling_sponserdSecdesk__UD6Sk","img":"onlineCounselling_img__h95e5","nav":"onlineCounselling_nav__6Eaz7","navLogo":"onlineCounselling_navLogo__L9uQK","maincontent":"onlineCounselling_maincontent__kuceR","hdraside":"onlineCounselling_hdraside__AAyfB","hdrbside":"onlineCounselling_hdrbside__070yR","fairdetails":"onlineCounselling_fairdetails__r4UP8","ulItem":"onlineCounselling_ulItem__AXOlg","heading":"onlineCounselling_heading__KzJs_","events":"onlineCounselling_events__XPvOs","time":"onlineCounselling_time__YM3vs","location":"onlineCounselling_location__fRVuW","icon":"onlineCounselling_icon__xgVT9","btnReg":"onlineCounselling_btnReg__zwI1J","regBtn":"onlineCounselling_regBtn__suf6j","bannerStudDiv":"onlineCounselling_bannerStudDiv__5EY6v","bg":"onlineCounselling_bg__sCE_t","mobileBreadCrum":"onlineCounselling_mobileBreadCrum__RwU_v","WhyKc":"onlineCounselling_WhyKc__A1DZw","viewMore":"onlineCounselling_viewMore__K0yiF","whyMb":"onlineCounselling_whyMb__J__Eh","studyabroadjourney":"onlineCounselling_studyabroadjourney__uN5Dd","OffersContent":"onlineCounselling_OffersContent__T3Aux","anchor":"onlineCounselling_anchor__fm1jn","worthgtry":"onlineCounselling_worthgtry__Vuc1m","worthgtrytext":"onlineCounselling_worthgtrytext__M0j2Z","worldisyourCampus":"onlineCounselling_worldisyourCampus__DPl38","clickTabsCountry":"onlineCounselling_clickTabsCountry___CVUY","flagsapn":"onlineCounselling_flagsapn__KMhs9","countryFlag":"onlineCounselling_countryFlag__FALA6","countryBox":"onlineCounselling_countryBox__yOE3t","flag":"onlineCounselling_flag___OLLI","universityTiups":"onlineCounselling_universityTiups__Hl_RL","sliderDots":"onlineCounselling_sliderDots__ecbxr","arrowsClass":"onlineCounselling_arrowsClass__tRIRR","btcircle":"onlineCounselling_btcircle__tKjLv","firstStep":"onlineCounselling_firstStep___enc0","stuImg":"onlineCounselling_stuImg__qefuV","whystuImg":"onlineCounselling_whystuImg__CM6BA","stuImgtext":"onlineCounselling_stuImgtext__auFvJ","stuImgd":"onlineCounselling_stuImgd__PF3SE","image":"onlineCounselling_image__ot7kA","stuImgtextd":"onlineCounselling_stuImgtextd__Dtfv7","headingSec":"onlineCounselling_headingSec__tHjKd","para":"onlineCounselling_para__b_L1P","StepContent":"onlineCounselling_StepContent__LOCZa","liItem":"onlineCounselling_liItem__Kwva6","studywithScholarship":"onlineCounselling_studywithScholarship__ZEGJs","footer":"onlineCounselling_footer__9FLsI","footerlogo":"onlineCounselling_footerlogo__Desyp"};

/***/ }),

/***/ 4391:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = all;

var _createChainableTypeChecker = __webpack_require__(82613);

var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function all() {
  for (var _len = arguments.length, validators = Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }

  function allPropTypes() {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    var error = null;

    validators.forEach(function (validator) {
      if (error != null) {
        return;
      }

      var result = validator.apply(undefined, args);
      if (result != null) {
        error = result;
      }
    });

    return error;
  }

  return (0, _createChainableTypeChecker2.default)(allPropTypes);
}
module.exports = exports['default'];

/***/ }),

/***/ 82613:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = createChainableTypeChecker;
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

// Mostly taken from ReactPropTypes.

function createChainableTypeChecker(validate) {
  function checkType(isRequired, props, propName, componentName, location, propFullName) {
    var componentNameSafe = componentName || '<<anonymous>>';
    var propFullNameSafe = propFullName || propName;

    if (props[propName] == null) {
      if (isRequired) {
        return new Error('Required ' + location + ' `' + propFullNameSafe + '` was not specified ' + ('in `' + componentNameSafe + '`.'));
      }

      return null;
    }

    for (var _len = arguments.length, args = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
      args[_key - 6] = arguments[_key];
    }

    return validate.apply(undefined, [props, propName, componentNameSafe, location, propFullNameSafe].concat(args));
  }

  var chainedCheckType = checkType.bind(null, false);
  chainedCheckType.isRequired = checkType.bind(null, true);

  return chainedCheckType;
}
module.exports = exports['default'];

/***/ }),

/***/ 26699:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_Breadcrumb; }
});

// EXTERNAL MODULE: ./node_modules/react-bootstrap/node_modules/classnames/index.js
var classnames = __webpack_require__(44036);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/ThemeProvider.js
var ThemeProvider = __webpack_require__(76792);
// EXTERNAL MODULE: ./node_modules/@restart/ui/esm/Anchor.js + 10 modules
var Anchor = __webpack_require__(23646);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/BreadcrumbItem.js





const defaultProps = {
  active: false,
  linkProps: {}
};
const BreadcrumbItem = /*#__PURE__*/react.forwardRef(({
  bsPrefix,
  active,
  children,
  className,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'li',
  linkAs: LinkComponent = Anchor/* default */.Z,
  linkProps,
  href,
  title,
  target,
  ...props
}, ref) => {
  const prefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'breadcrumb-item');
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    ref: ref,
    ...props,
    className: classnames_default()(prefix, className, {
      active
    }),
    "aria-current": active ? 'page' : undefined,
    children: active ? children : /*#__PURE__*/(0,jsx_runtime.jsx)(LinkComponent, { ...linkProps,
      href: href,
      title: title,
      target: target,
      children: children
    })
  });
});
BreadcrumbItem.displayName = 'BreadcrumbItem';
BreadcrumbItem.defaultProps = defaultProps;
/* harmony default export */ var esm_BreadcrumbItem = (BreadcrumbItem);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/Breadcrumb.js





const Breadcrumb_defaultProps = {
  label: 'breadcrumb',
  listProps: {}
};
const Breadcrumb = /*#__PURE__*/react.forwardRef(({
  bsPrefix,
  className,
  listProps,
  children,
  label,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'nav',
  ...props
}, ref) => {
  const prefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'breadcrumb');
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    "aria-label": label,
    className: className,
    ref: ref,
    ...props,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("ol", { ...listProps,
      className: classnames_default()(prefix, listProps == null ? void 0 : listProps.className),
      children: children
    })
  });
});
Breadcrumb.displayName = 'Breadcrumb';
Breadcrumb.defaultProps = Breadcrumb_defaultProps;
/* harmony default export */ var esm_Breadcrumb = (Object.assign(Breadcrumb, {
  Item: esm_BreadcrumbItem
}));

/***/ }),

/***/ 49059:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

const context = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext(null);
context.displayName = 'CardHeaderContext';
/* harmony default export */ __webpack_exports__["Z"] = (context);

/***/ }),

/***/ 80957:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ react_bootstrap_esm_Nav; }
});

// EXTERNAL MODULE: ./node_modules/react-bootstrap/node_modules/classnames/index.js
var classnames = __webpack_require__(44036);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/prop-types-extra/lib/all.js
var lib_all = __webpack_require__(4391);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/uncontrollable/lib/esm/index.js + 4 modules
var esm = __webpack_require__(47150);
// EXTERNAL MODULE: ./node_modules/dom-helpers/esm/querySelectorAll.js
var querySelectorAll = __webpack_require__(60930);
;// CONCATENATED MODULE: ./node_modules/@restart/hooks/esm/useForceUpdate.js

/**
 * Returns a function that triggers a component update. the hook equivalent to
 * `this.forceUpdate()` in a class component. In most cases using a state value directly
 * is preferable but may be required in some advanced usages of refs for interop or
 * when direct DOM manipulation is required.
 *
 * ```ts
 * const forceUpdate = useForceUpdate();
 *
 * const updateOnClick = useCallback(() => {
 *  forceUpdate()
 * }, [forceUpdate])
 *
 * return <button type="button" onClick={updateOnClick}>Hi there</button>
 * ```
 */

function useForceUpdate() {
  // The toggling state value is designed to defeat React optimizations for skipping
  // updates when they are stricting equal to the last state value
  var _useReducer = (0,react.useReducer)(function (state) {
    return !state;
  }, false),
      dispatch = _useReducer[1];

  return dispatch;
}
// EXTERNAL MODULE: ./node_modules/@restart/hooks/esm/useMergedRefs.js
var useMergedRefs = __webpack_require__(35654);
// EXTERNAL MODULE: ./node_modules/@restart/ui/esm/NavContext.js
var NavContext = __webpack_require__(86056);
// EXTERNAL MODULE: ./node_modules/@restart/ui/esm/SelectableContext.js
var SelectableContext = __webpack_require__(87126);
// EXTERNAL MODULE: ./node_modules/@restart/ui/esm/TabContext.js
var TabContext = __webpack_require__(76626);
// EXTERNAL MODULE: ./node_modules/@restart/ui/esm/DataKey.js
var DataKey = __webpack_require__(52747);
// EXTERNAL MODULE: ./node_modules/@restart/ui/esm/NavItem.js
var NavItem = __webpack_require__(73716);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@restart/ui/esm/Nav.js
const _excluded = ["as", "onSelect", "activeKey", "role", "onKeyDown"];

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }













// eslint-disable-next-line @typescript-eslint/no-empty-function
const noop = () => {};

const EVENT_KEY_ATTR = (0,DataKey/* dataAttr */.PB)('event-key');
const Nav = /*#__PURE__*/react.forwardRef((_ref, ref) => {
  let {
    // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'div',
    onSelect,
    activeKey,
    role,
    onKeyDown
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  // A ref and forceUpdate for refocus, b/c we only want to trigger when needed
  // and don't want to reset the set in the effect
  const forceUpdate = useForceUpdate();
  const needsRefocusRef = (0,react.useRef)(false);
  const parentOnSelect = (0,react.useContext)(SelectableContext/* default */.Z);
  const tabContext = (0,react.useContext)(TabContext/* default */.Z);
  let getControlledId, getControllerId;

  if (tabContext) {
    role = role || 'tablist';
    activeKey = tabContext.activeKey; // TODO: do we need to duplicate these?

    getControlledId = tabContext.getControlledId;
    getControllerId = tabContext.getControllerId;
  }

  const listNode = (0,react.useRef)(null);

  const getNextActiveTab = offset => {
    const currentListNode = listNode.current;
    if (!currentListNode) return null;
    const items = (0,querySelectorAll/* default */.Z)(currentListNode, `[${EVENT_KEY_ATTR}]:not([aria-disabled=true])`);
    const activeChild = currentListNode.querySelector('[aria-selected=true]');
    if (!activeChild || activeChild !== document.activeElement) return null;
    const index = items.indexOf(activeChild);
    if (index === -1) return null;
    let nextIndex = index + offset;
    if (nextIndex >= items.length) nextIndex = 0;
    if (nextIndex < 0) nextIndex = items.length - 1;
    return items[nextIndex];
  };

  const handleSelect = (key, event) => {
    if (key == null) return;
    onSelect == null ? void 0 : onSelect(key, event);
    parentOnSelect == null ? void 0 : parentOnSelect(key, event);
  };

  const handleKeyDown = event => {
    onKeyDown == null ? void 0 : onKeyDown(event);

    if (!tabContext) {
      return;
    }

    let nextActiveChild;

    switch (event.key) {
      case 'ArrowLeft':
      case 'ArrowUp':
        nextActiveChild = getNextActiveTab(-1);
        break;

      case 'ArrowRight':
      case 'ArrowDown':
        nextActiveChild = getNextActiveTab(1);
        break;

      default:
        return;
    }

    if (!nextActiveChild) return;
    event.preventDefault();
    handleSelect(nextActiveChild.dataset[(0,DataKey/* dataProp */.$F)('EventKey')] || null, event);
    needsRefocusRef.current = true;
    forceUpdate();
  };

  (0,react.useEffect)(() => {
    if (listNode.current && needsRefocusRef.current) {
      const activeChild = listNode.current.querySelector(`[${EVENT_KEY_ATTR}][aria-selected=true]`);
      activeChild == null ? void 0 : activeChild.focus();
    }

    needsRefocusRef.current = false;
  });
  const mergedRef = (0,useMergedRefs/* default */.Z)(ref, listNode);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(SelectableContext/* default.Provider */.Z.Provider, {
    value: handleSelect,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(NavContext/* default.Provider */.Z.Provider, {
      value: {
        role,
        // used by NavLink to determine it's role
        activeKey: (0,SelectableContext/* makeEventKey */.h)(activeKey),
        getControlledId: getControlledId || noop,
        getControllerId: getControllerId || noop
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Component, Object.assign({}, props, {
        onKeyDown: handleKeyDown,
        ref: mergedRef,
        role: role
      }))
    })
  });
});
Nav.displayName = 'Nav';
/* harmony default export */ var esm_Nav = (Object.assign(Nav, {
  Item: NavItem/* default */.Z
}));
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/ThemeProvider.js
var ThemeProvider = __webpack_require__(76792);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/NavbarContext.js
 // TODO: check

const context = /*#__PURE__*/react.createContext(null);
context.displayName = 'NavbarContext';
/* harmony default export */ var NavbarContext = (context);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/CardHeaderContext.js
var CardHeaderContext = __webpack_require__(49059);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/NavItem.js
var esm_NavItem = __webpack_require__(41244);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/NavLink.js
var NavLink = __webpack_require__(14691);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/Nav.js












const defaultProps = {
  justify: false,
  fill: false
};
const Nav_Nav = /*#__PURE__*/react.forwardRef((uncontrolledProps, ref) => {
  const {
    as = 'div',
    bsPrefix: initialBsPrefix,
    variant,
    fill,
    justify,
    navbar,
    navbarScroll,
    className,
    activeKey,
    ...props
  } = (0,esm/* useUncontrolled */.Ch)(uncontrolledProps, {
    activeKey: 'onSelect'
  });
  const bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(initialBsPrefix, 'nav');
  let navbarBsPrefix;
  let cardHeaderBsPrefix;
  let isNavbar = false;
  const navbarContext = (0,react.useContext)(NavbarContext);
  const cardHeaderContext = (0,react.useContext)(CardHeaderContext/* default */.Z);

  if (navbarContext) {
    navbarBsPrefix = navbarContext.bsPrefix;
    isNavbar = navbar == null ? true : navbar;
  } else if (cardHeaderContext) {
    ({
      cardHeaderBsPrefix
    } = cardHeaderContext);
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(esm_Nav, {
    as: as,
    ref: ref,
    activeKey: activeKey,
    className: classnames_default()(className, {
      [bsPrefix]: !isNavbar,
      [`${navbarBsPrefix}-nav`]: isNavbar,
      [`${navbarBsPrefix}-nav-scroll`]: isNavbar && navbarScroll,
      [`${cardHeaderBsPrefix}-${variant}`]: !!cardHeaderBsPrefix,
      [`${bsPrefix}-${variant}`]: !!variant,
      [`${bsPrefix}-fill`]: fill,
      [`${bsPrefix}-justified`]: justify
    }),
    ...props
  });
});
Nav_Nav.displayName = 'Nav';
Nav_Nav.defaultProps = defaultProps;
/* harmony default export */ var react_bootstrap_esm_Nav = (Object.assign(Nav_Nav, {
  Item: esm_NavItem/* default */.Z,
  Link: NavLink/* default */.Z
}));

/***/ }),

/***/ 41244:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _createWithBsPrefix__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66611);

/* harmony default export */ __webpack_exports__["Z"] = ((0,_createWithBsPrefix__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)('nav-item'));

/***/ }),

/***/ 14691:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44036);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _restart_ui_Anchor__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23646);
/* harmony import */ var _restart_ui_NavItem__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(73716);
/* harmony import */ var _restart_ui_SelectableContext__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(87126);
/* harmony import */ var _ThemeProvider__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(76792);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);







const defaultProps = {
  disabled: false
};
const NavLink = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(({
  bsPrefix,
  className,
  as: Component = _restart_ui_Anchor__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z,
  active,
  eventKey,
  ...props
}, ref) => {
  bsPrefix = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_4__/* .useBootstrapPrefix */ .vE)(bsPrefix, 'nav-link');
  const [navItemProps, meta] = (0,_restart_ui_NavItem__WEBPACK_IMPORTED_MODULE_5__/* .useNavItem */ .v)({
    key: (0,_restart_ui_SelectableContext__WEBPACK_IMPORTED_MODULE_6__/* .makeEventKey */ .h)(eventKey, props.href),
    active,
    ...props
  });
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Component, { ...props,
    ...navItemProps,
    ref: ref,
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(className, bsPrefix, props.disabled && 'disabled', meta.isActive && 'active')
  });
});
NavLink.displayName = 'NavLink';
NavLink.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["Z"] = (NavLink);

/***/ })

}]);